// Vendors
import {
  TrackingEventsEnum,
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@openbank/ziniaweb-ui-core-models';
// Types
import { TrackBuilderType } from 'types/track-builder.type';
import { ProofIncomeLandingTrackingHandlersType } from './types/proof-income-landing.tracking.handlers.type';
// Utils
import {
  mapMethodToModalTracking,
  mapMethodToTracking,
} from './utils/proof-income-landing.tracking.handlers.utils';

const trackProofIncomeViewHandler = (): TrackingViewEventReturnType => ({
  payload: {
    pageName: '/proofOfIncome/step_3',
    sectionFamily: 'customer',
    sectionCategory: 'orders',
    sectionName: 'lending',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'proofOfIncome',
    processStep: 'step_3',
  },
  type: TrackingEventsEnum.VIEW,
});

const trackProofIncomeSelectMethodHandler = (method: string): TrackingLinkEventReturnType => ({
  payload: {
    action: 'select',
    format: 'radioButton',
    component: 'form',
    element: mapMethodToTracking(method),
    eventCategory: 'ProofOfIncome',
    eventAction: 'clickRadioButton',
    eventLabel: mapMethodToTracking(method),
  },
  type: TrackingEventsEnum.LINK,
});

const trackProofIncomeContinueHandler = (method: string): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: 'form',
    element: 'continue',
    data: `verificationMethods/radioButton/${mapMethodToTracking(method)}`,
    eventCategory: 'ProofOfIncome',
    eventAction: 'clickButton',
    eventLabel: `${mapMethodToTracking(method)}continueButton`,
  },
  type: TrackingEventsEnum.LINK,
});

const trackProofIncomeOpenModalHandler = (method: string): TrackingLinkEventReturnType => ({
  payload: {
    action: 'open',
    format: 'modal',
    component: `modalContainer/verifyWith${mapMethodToModalTracking(method)}`,
    element: 'full',
    eventCategory: 'ProofOfIncome',
    eventAction: `modalVerifyWith${mapMethodToModalTracking(method)}`,
    eventLabel: 'open',
  },
  type: TrackingEventsEnum.LINK,
});

const trackProofIncomeCloseModalHandler = (method: string): TrackingLinkEventReturnType => ({
  payload: {
    action: 'close',
    format: 'cross',
    component: `modalContainer/verifyWith${mapMethodToModalTracking(method)}`,
    element: 'cross',
    eventCategory: 'ProofOfIncome',
    eventAction: `modalVerifyWith${mapMethodToModalTracking(method)}`,
    eventLabel: 'close',
  },
  type: TrackingEventsEnum.LINK,
});

const trackProofIncomeConfirmHandler = (method: string): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: `modalContainer/verifyWith${mapMethodToModalTracking(method)}`,
    element: 'continue',
    eventCategory: 'ProofOfIncome',
    eventAction: `modalVerifyWith${mapMethodToModalTracking(method)}`,
    eventLabel: 'continueButton',
  },
  type: TrackingEventsEnum.LINK,
});

const ProofIncomeLandingTrackingHandlers = (
  track: TrackBuilderType
): ProofIncomeLandingTrackingHandlersType => ({
  handleTrackView: () => track(trackProofIncomeViewHandler()),
  handleTrackSelectMethod: (method: string) => track(trackProofIncomeSelectMethodHandler(method)),
  handleTrackContinue: (method: string) => track(trackProofIncomeContinueHandler(method)),
  handleTrackOpenModal: (method: string) => track(trackProofIncomeOpenModalHandler(method)),
  handleTrackCloseModal: (method: string) => track(trackProofIncomeCloseModalHandler(method)),
  handleTrackConfirm: (method: string) => track(trackProofIncomeConfirmHandler(method)),
});

export { ProofIncomeLandingTrackingHandlers };
